import { useQuery } from "@tanstack/react-query";
import { api } from "shared/api";
import {
  OptionTemplate,
  OptionTemplateByFilterPayload,
} from "shared/api/middleware-api-client";

const sortByOrderMap = (
  layouts: OptionTemplate[],
  orderMap: Record<string, number>,
) => {
  return layouts.sort((a, b) => {
    const ao = orderMap[a.code];
    const bo = orderMap[b.code];
    if (ao > bo) return 1;
    if (ao === bo) return 0;
    return -1;
  });
};

const fetchDoorOptionsFromAPI = async (
  payload: OptionTemplateByFilterPayload,
) => {
  const res = await api().gersGetOptionTemplatesByFilter(payload);

  // The catalog uses null for no extras; configurator consumers expect a list.
  const doorOptions = { ...res.data, extra: res.data.extra ?? [] };
  return doorOptions;
};

const useDoorOptions = (
  payload: OptionTemplateByFilterPayload,
  orderMap: Record<string, number>,
) => {
  const {
    data: doorOptions,
    isFetching: doorOptionsLoading,
    isError: doorOptionsLoadError,
  } = useQuery({
    queryKey: [`get-door-configuration-options`],
    queryFn: () => fetchDoorOptionsFromAPI(payload),
    enabled: payload.door !== "",
    refetchOnWindowFocus: false,
    staleTime: 0,
    // Transform result once: immutably sort layout if present
    select: (data) => {
      if (!data?.layout) return data;
      return {
        ...data,
        layout: sortByOrderMap([...data.layout], orderMap),
      };
    },
  });

  return {
    doorOptions,
    doorOptionsLoading,
    doorOptionsLoadError,
  };
};
export default useDoorOptions;
